'use client';

import { Box, Flex, Grid, GridItem, Text, useTheme } from '@chakra-ui/react';

import { PackageItem as PackageItemType } from 'types';

import { Divider } from 'ui';

interface PackageItemProps {
  item: PackageItemType;
  isLastItem: boolean;
}

const SubPackageItem = ({ item, isLastItem }: PackageItemProps) => {
  const {
    colors: {
      palette: {
        dashboard: {
          packages: {
            packagePage: {
              subPackageList: { subPackageItem }
            }
          }
        }
      }
    }
  } = useTheme();

  return (
    <Box>
      <Grid
        position='relative'
        templateColumns='repeat(6, 1fr)'
        templateRows={{
          base: 'repeat(3, auto)',
          lg: 'repeat(1, 1fr)'
        }}
        px='20px'
        py={{ base: '21px', lg: '17px' }}
        columnGap='10px'
        rowGap='15px'
      >
        <GridItem colSpan={{ base: 6, lg: 3 }} gridRowStart={1}>
          <Flex h='100%' alignItems='center' justifyContent='start'>
            <Text
              fontSize='20px'
              fontWeight={{ base: 'semibold', lg: 'normal' }}
              color={subPackageItem.nameTextColor}
            >
              {item.svc_name}
            </Text>
          </Flex>
        </GridItem>
        <GridItem
          gridRowStart={{ base: 3, lg: 1 }}
          colSpan={{ base: 2, lg: 1 }}
        >
          <Flex
            height='100%'
            justifyContent='center'
            gap='10px'
            width={{ base: 'fit-content', lg: 'auto' }}
            alignItems='center'
            flexDirection={{
              base: 'column',
              lg: 'row'
            }}
          >
            <Text
              display={{ base: 'block', lg: 'none' }}
              fontSize='12px'
              color={subPackageItem.qtyLabelColor}
              textTransform='uppercase'
            >
              QTY
            </Text>
            <Text fontSize='16px' color={subPackageItem.qtyTextColor}>
              {item.usable_qty}
            </Text>
          </Flex>
        </GridItem>

        <GridItem
          display={{ base: 'block', lg: 'none' }}
          colSpan={6}
          gridRowStart={2}
        >
          <Divider
            position='absolute'
            bg={subPackageItem.dividerColor}
            opacity={0.3}
            width={{ base: 'calc(100% - 40px)', lg: 'calc(100% - 10px)' }}
            left={{ base: '20px', lg: '5px' }}
          />
        </GridItem>

        <GridItem
          gridRowStart={{ base: 3, lg: 1 }}
          colSpan={{ base: 2, lg: 1 }}
        >
          <Flex
            height='100%'
            justifyContent='center'
            gap='10px'
            alignItems='center'
            flexDirection={{
              base: 'column',
              lg: 'row'
            }}
          >
            <Text
              display={{ base: 'block', lg: 'none' }}
              fontSize='12px'
              color={subPackageItem.usedLabelColor}
              textTransform='uppercase'
            >
              Used
            </Text>
            <Text fontSize='16px' color={subPackageItem.usedTextColor}>
              {item.used_qty}
            </Text>
          </Flex>
        </GridItem>
        <GridItem
          gridRowStart={{ base: 3, lg: 1 }}
          colSpan={{ base: 2, lg: 1 }}
        >
          <Flex
            height='100%'
            justifyContent='center'
            gap='10px'
            ml='auto'
            width={{ base: 'fit-content', lg: 'auto' }}
            alignItems='center'
            flexDirection={{
              base: 'column',
              lg: 'row'
            }}
          >
            <Text
              display={{ base: 'block', lg: 'none' }}
              fontSize='12px'
              color={subPackageItem.remainingLabelColor}
              textTransform='uppercase'
            >
              Remaining
            </Text>
            <Text
              fontSize='16px'
              color={subPackageItem.remainingTextColor}
              textTransform='uppercase'
            >
              {item.usable_qty}
            </Text>
          </Flex>
        </GridItem>
      </Grid>

      {!isLastItem && (
        <Divider
          position='absolute'
          bg={{
            base: subPackageItem.mobileDividerColor,
            lg: subPackageItem.dividerColor
          }}
          opacity={{ lg: 0.3 }}
          width={{ base: '100%', lg: 'calc(100% - 40px)' }}
          left={{ lg: '20px' }}
        />
      )}
    </Box>
  );
};

export default SubPackageItem;
